import axios from "axios";

export function formatDirectINSEEaddress(record, fullAddress = true) {
    let address = ""
    if (record.adresseEtablissement) {
        if (fullAddress) {
            if (record.adresseEtablissement.numeroVoieEtablissement) address += record.adresseEtablissement.numeroVoieEtablissement + " "
        }
        if (record.adresseEtablissement.typeVoieEtablissement) address += record.adresseEtablissement.typeVoieEtablissement + " "
        if (record.adresseEtablissement.libelleVoieEtablissement) address += record.adresseEtablissement.libelleVoieEtablissement + " "
        if (!fullAddress) return address
        if (record.adresseEtablissement.codePostalEtablissement) address += record.adresseEtablissement.codePostalEtablissement + " "
        if (record.adresseEtablissement.libelleCommuneEtablissement) address += record.adresseEtablissement.libelleCommuneEtablissement
    }
    return address.length ? address : null
}

export async function fetchDirectINSEE(q) {
    try {
        const json = await axios.get("https://api.insee.fr/api-sirene/3.11/siret?q=" + q, {
            headers: {'X-INSEE-Api-Key-Integration': '105b36b6-880f-411d-9b36-b6880fe11dd2'}
        })
        return json
    } catch (error) {
        return {etablissements : []}
    }
}